import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@material-ui/core'
import { VolumeOffOutlined } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectAutoPlayUnlocker,
  selectProductTour,
  setAutoPlayUnlocker,
  selectTencentConnectionDialog,
} from '../reducers/uiSlice'

const AutoPlayUnlocker = ({ children }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { open } = useSelector(selectAutoPlayUnlocker)
  const productTour = useSelector(selectProductTour)
  const connectionDialog = useSelector(selectTencentConnectionDialog)

  /**
   * Si el cartel de "no es posible reproducir el video" está abierto, no se le pide al
   * espectador que active el sonido: son dos modales apilados sobre el mismo problema, y el
   * de audio quedaba encima tapando el que explica qué pasó. Además no tiene sentido ofrecer
   * sonido de algo que no se está viendo.
   */
  const suppressed = connectionDialog.open === true

  const handleOnClose = () => {
    if (productTour.isActive) return
    dispatch(setAutoPlayUnlocker({ requestUnmute: true, open: false }))
  }

  return (
    <>
      {children}
      <AutoPlayUnlocker.Container
        open={open && !suppressed}
        productTourActive={productTour.isActive}
        onClick={handleOnClose}
      >
        <AutoPlayUnlocker.Icon />
        <AutoPlayUnlocker.Content>
          {t('dialogs.autoPlayUnlocker.dialogContentText')}
        </AutoPlayUnlocker.Content>
      </AutoPlayUnlocker.Container>
    </>
  )
}

AutoPlayUnlocker.Icon = styled(VolumeOffOutlined)`
  text-align: center;
  margin-top: 2rem;
  font-size: 2.5rem;
`
AutoPlayUnlocker.Container = styled(Dialog)`
  .MuiDialog-paper {
    visibility: ${(props) => (props.productTourActive ? 'hidden' : 'visible')};
    border-radius: 0.5rem;
    font-size: 0.9em;
    align-items: center;
    max-width: 10rem;
  }
`
AutoPlayUnlocker.Content = styled(DialogContent)`
  text-align: center;
  font-weight: 600;
  color: black;
  line-height: 1rem;
  &.MuiDialogContent-root {
    padding: 1.05rem 1.5rem 1.05rem 1.5rem;
  }
`

AutoPlayUnlocker.propTypes = {
  children: PropTypes.any,
}

export { AutoPlayUnlocker }
